import analyticsHandlers from "../../pages/helpers/analyticsHandlers";
import { convertLanguage, getViewContext } from "../../pages/helpers/analytics";

/*
 * Throttling function for scrolling events
 */
function throttle(delay, callback) {
  var previousCall = new Date().getTime();
  return function () {
    var time = new Date().getTime();

    if (time - previousCall >= delay) {
      previousCall = time;
      callback.apply(null, arguments);
    }
  };
}

const checkForProdOrTest = url =>
  url.match(/^https?\:\/\/www\.plangrid\.com/) ||
  url.match(/plangrid(\.com)?\/public\//);

const checkForAmplitude = () =>
  typeof window !== "undefined" && typeof amplitude !== "undefined";

export const trackEvent = (event, payload) => {
  if (checkForProdOrTest(window.location.href)) {
    if (checkForAmplitude()) {
      payload
        ? amplitude.getInstance().logEvent(event, payload)
        : amplitude.getInstance().logEvent(event);
    }
    else {
      setTimeout(trackEvent, 1000);
    }
  } else {
    console.log("EVENT: ", event, payload);
  }
};

const getDataHandlerAttr = node => node.getAttribute("data-analytics-handler");

const getEventData = (handler, currentPage, node) => {
  const eventData = analyticsHandlers[handler];

  if (!eventData) {
    console.warn(
      `No analytics handler for: ${handler}, page: ${currentPage}, node: ${node}`
    );
    return false;
  }

  return analyticsHandlers[handler](currentPage, node);
};

const attachClickEvent = (node, eventName, payload) => {
  node.addEventListener("click", e => {
    trackEvent(eventName, payload);
  });
};

const attachHoverEvent = (node, eventName, payload) => {
  node.addEventListener("mouseenter", e => {
    e.stopPropagation();
    trackEvent(eventName, payload);
  });
};

const attachHoverNoClickEvent = (node, eventName, payload) => {
  node.addEventListener("mouseenter", e => {
    var clicked = false;
    var called = false;

    node.addEventListener("mousedown", () => {
      clicked = true;
    });

    node.addEventListener("mouseout", e => {
      if (!clicked && !called) {
        trackEvent(eventName, payload);
        called = true;
      }

      node.removeEventListener("mousedown");
      node.removeEventListener("mouseout");
    });
  });
};

const checkEventOptions = (pageName, options) => {
  if (!(options && options.ignoreView)) {
    trackEvent("public_web.page.view", getViewContext(pageName));
  }
  if (options && options.trackScrolling) {
    addScrollEvent(pageName);
  }
};

const addCampaignTracking = () => {
  var campaignUtils = {};

  /*
   * Turn query param string into a hash.
   */
  campaignUtils.deparam = function deparam(str) {
    var pairs, hash;
    // remove the '?'
    if (!str || !str.length) {
      return;
    }

    if (str[0] === "?") {
      str = str.slice(1);
    }
    str = decodeURIComponent(str);

    // this gives back something of the form: [[key1, val1], [key2, val2]]
    pairs = str.split("&").map(item => {
      return item.split("=");
    });

    hash = {};
    pairs.forEach(pair => {
      hash[pair[0]] = pair[1];
    });

    return hash;
  };

  campaignUtils.extractCampaignAttributionData = function extractCampaignAttributionData(
    queryParams
  ) {
    var campaignFields, campaignData;
    campaignFields = [
      "utm_source",
      "utm_medium",
      "utm_term",
      "utm_content",
      "utm_campaign",
    ];
    campaignData = {};

    queryParams &&
      campaignFields.forEach(field => {
        if (queryParams[field]) {
          campaignData[field] = queryParams[field];
        }
      });

    return campaignData;
  };

  var query, campaignData;
  query = campaignUtils.deparam(window.location.search);
  campaignData = campaignUtils.extractCampaignAttributionData(query);
  if (campaignData && campaignData.utm_campaign) {
    analytics.track("campaign", campaignData);
  }
};

const addScrollEvent = pageName => {
  var sections = [].slice.call(document.querySelectorAll("section"));

  window.onscroll = throttle(300, () => {
    sections.forEach((thisSection, index, sectionArray) => {
      var eventProperties = {};

      if (window.pageYOffset >= thisSection.offsetTop) {
        eventProperties.page_element = thisSection.getAttribute(
          "data-scroll-element"
        );
        trackEvent(`splash.${pageName}.scroll`, eventProperties);
        sections.splice(index, 1);
      }
    });
  });
};

const getAnalyticsHandlers = node =>
  getDataHandlerAttr(node)
    .split(",")
    .map(el => el.trim());

const attachAnalyticsToDOM = (currentPage, options) => {
  document.querySelectorAll("[data-analytics-handler]").forEach(node => {
    const handlers = getAnalyticsHandlers(node);

    handlers.forEach(handler => {
      const eventData = getEventData(handler, currentPage, node);

      if (!eventData) {
        return;
      }

      const { eventType, eventName, payload } = eventData;

      if (eventType === "click") {
        attachClickEvent(node, eventName, payload);
      }

      if (eventType === "hover") {
        attachHoverEvent(node, eventName, payload);
      }

      if (eventType === "hover-no-click") {
        attachHoverNoClickEvent(node, eventName, payload);
      }
    });
  });
};

const plangridTrackEvents = (pageName, options) => {
  checkEventOptions(pageName, options);
  addCampaignTracking();
  attachAnalyticsToDOM(pageName);
};

export default plangridTrackEvents;



// WEBPACK FOOTER //
// ./src/assets/js/amplitudeInit-vanilla.js